import React, { FC, useCallback, useRef, useState } from 'react';
import classNames from 'classnames';
import { OrderListState } from '../../store/orderlist/state';
import { Popover } from '../../shared/components/Popover/Popover';

import './PrivacyButton.scss';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly orderlist: OrderListState;
    readonly changeVisibility: (shared: boolean) => void;
    readonly className?: string;
};

const PrivacyButton: FC<Props> = ({ orderlist, changeVisibility, className }) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const isShared = orderlist.shared;

    const icon = isShared ? 'group' : 'person';

    const onToggle = useCallback(() => {
        setExpanded(it => !it);
    }, []);

    const onChange = useCallback(
        (state: boolean) => {
            changeVisibility(state);
            setExpanded(false);
        },
        [changeVisibility]
    );

    return (
        <>
            <div className={classNames(className, 'privacy-button')} ref={ref} onClick={onToggle}>
                <i className="material-icons main-icon">{icon}</i>
                <i className="material-icons toggle-icon">{expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
            </div>
            <Popover
                target={ref}
                placement="bottom"
                visible={expanded}
                className="privacy-button-popover"
                onClose={() => setExpanded(false)}
            >
                <ul>
                    <li>
                        <a onClick={() => onChange(true)}>
                            <i className="material-icons">group</i>
                            &nbsp; {t('selectionList.privacy.visibleToAll')}
                            {isShared && <i className="material-icons check">check</i>}
                        </a>
                    </li>
                    <li>
                        <a onClick={() => onChange(false)}>
                            <i className="material-icons">person</i>
                            &nbsp; {t('selectionList.privacy.onlyToMe')}
                            {!isShared && <i className="material-icons check">check</i>}
                        </a>
                    </li>
                </ul>
            </Popover>
        </>
    );
};

export default PrivacyButton;
